define(['marionette', 'swiper'], function (Marionette, Swiper) {
  return Marionette.ItemView.extend({
    template: false,

    ui: {
      prevButton: '.js-swiper-button-prev',
      nextButton: '.js-swiper-button-next'
    },

    events: {
      'click @ui.prevButton': 'prevButtonSlide',
      'click @ui.nextButton': 'nextButtonSlide'
    },

    // Future elements
    // prevButtonSlide: function() {},
    // nextButtonSlide: function( ) {},

    initialize: function () {
      var count = this.$el.find('.swiper-slide').length
      var totalLarge = count >= 3 ? 3 : count
      var totalMedium = count >= 2 ? 2 : count

      // initialize the swiper
      return new Swiper(this.$el, {
        spaceBetween: 20,
        slidesPerView: totalLarge,
        loop: false,
        simulateTouch: false,
        breakpoints: {
          1920: {
            slidesPerView: totalLarge,
            loop: false
          },

          768: {
            slidesPerView: totalMedium,
            loop: true,
            simulateTouch: true
          },

          414: {
            slidesPerView: 1,
            loopAdditionalSlides: 1,
            loopedSlides: 1,
            width: 300,
            loop: true,
            simulateTouch: true
          },

          320: {
            width: 280,
            simulateTouch: true
          }
        }
      })
    }
  })
})
